<app-card label="Latest CCDA Document" height="{{ calcCardHeight() }}">
  <dx-scroll-view height="{{ calcScrollViewHeight() }}"
  [scrollByContent]="true"
  >
    <div #content data-recording-disable></div>
  </dx-scroll-view>
</app-card>
